import { parseDescopeTheme } from 'modules/theme/parseDescopeTheme';
import { DescopeTheme, ParsedDescopeTheme } from 'modules/theme/theme';
import { useQuery } from 'react-query';
import { useProjectCtx } from 'state/project/ProjectCtx';
import { useAdminPortalConfig } from './adminPortalConfig';
import { getStatic } from './api';
import { API_ROUTES, qk } from './apiRoutes';

const getTheme = async (
	projectId: string,
	styleId: string
): Promise<ParsedDescopeTheme> => {
	const themeRes = await getStatic<DescopeTheme>(
		API_ROUTES.theme(projectId, styleId)
	);
	return parseDescopeTheme(themeRes.data);
};

export const useParsedTheme = (enabled: boolean = true) => {
	const { projectId } = useProjectCtx();
	const { data: appConfigData } = useAdminPortalConfig();

	return useQuery({
		queryKey: qk.theme(),
		queryFn: () => getTheme(projectId!, appConfigData?.styleId || 'theme'),
		staleTime: Infinity,
		enabled: !!(enabled && projectId && appConfigData),
		refetchOnWindowFocus: false,
		retry: false
	});
};
